import {useEffect, useState} from "react";
import {create, destroy, get, update} from "custom/demo/requests/admin/validation-studies";
import {list as listSurveys} from "custom/demo/requests/admin/validation-surveys";
import Field from "components/helpers/form/field";
import useForm from "custom/demo/helpers/admin/use-form";

const partnerOptions = [
  {name: "Dynata", value: "Dynata"},
  {name: "Prolific", value: "Prolific"},
  {name: "Test", value: "Test"}
];

const styleOptions = [
  {name: "Default", value: "Default"},
  {name: "Default - UK", value: "Default - UK"},
  {name: "Cognitive", value: "Cognitive"},
  {name: "Cognitive - Convergent", value: "Cognitive - Convergent"},
  {name: "Cognitive - UK", value: "Cognitive - UK"},
  {name: "Cognitive Test => Retest", value: "Cognitive Test => Retest"},
  {name: "Cognitive Timed => Untimed", value: "Cognitive Timed => Untimed"},
  {name: "Cognitive Untimed => Timed", value: "Cognitive Untimed => Timed"},
  {name: "Recruitment", value: "Recruitment"}
];

const defaults = {
  external_id: "",
  form_instructions: "",
  name: "",
  partner: "Dynata",
  partner_rejection_url: "",
  partner_success_url: "",
  retest_survey_ids: ["", "", "", "", ""],
  retest_survey_options: ["", "", "", "", ""],
  signed_links: false,
  style: "Default",
  survey_ids: ["", "", "", "", ""],
  survey_options: ["", "", "", "", ""]
};

export default function Form() {
  const {id, onChange, onDestroy, onSubmit, record, setRecord} = useForm({
    actions: {create, destroy, get, update}, defaults, path: "/admin/validation/studies"
  });
  const [surveyOptions, setSurveyOptions] = useState([]);

  useEffect(() => {
    listSurveys().then((data) => {
      setSurveyOptions(data.records.map((s) => ({name: s.name, value: String(s.id)})));
    });
  }, []);

  const onArrayChange = (field, index) => (e) => {
    const updated = [...record[field]];
    updated[index] = e.target.value;
    setRecord({...record, [field]: updated});
  };

  return (
    <div className="container">
      <h1>Validation Study</h1>
      <form onSubmit={onSubmit}>
        <Field
          label="External ID"
          name="external_id"
          onChange={onChange}
          placeholder="External ID"
          required={true}
          value={record.external_id}
        />
        <label className="block mb-2" htmlFor="form_instructions">
          <div>Form Instructions</div>
          <textarea
            id="form_instructions"
            name="form_instructions"
            onChange={onChange}
            placeholder="Form Instructions"
            value={record.form_instructions || ""}
          />
        </label>
        <Field
          label="Name"
          name="name"
          onChange={onChange}
          placeholder="Name"
          required={true}
          value={record.name}
        />
        <Field
          label="Partner"
          name="partner"
          onChange={onChange}
          options={partnerOptions}
          type="select"
          value={record.partner}
        />
        <Field
          label="Partner Rejection URL"
          name="partner_rejection_url"
          onChange={onChange}
          placeholder="Partner Rejection URL (optional)"
          value={record.partner_rejection_url}
        />
        <Field
          label="Partner Success URL"
          name="partner_success_url"
          onChange={onChange}
          placeholder="Partner Success URL (optional)"
          value={record.partner_success_url}
        />
        <Field
          checked={record.signed_links}
          label="Signed Links"
          name="signed_links"
          onChange={onChange}
          type="checkbox"
        />
        <Field
          label="Style"
          name="style"
          onChange={onChange}
          options={styleOptions}
          type="select"
          value={record.style}
        />
        <div className="mb-2">
          <div>Surveys</div>
          {[0, 1, 2, 3, 4].map((index) => (
            <div className="flex gap-2 mb-1" key={`survey-${index}`}>
              <Field
                label=""
                name={`survey_ids_${index}`}
                onChange={onArrayChange("survey_ids", index)}
                options={surveyOptions}
                placeholder="None"
                type="select"
                value={String(record.survey_ids[index] || "")}
              />
              <textarea
                onChange={onArrayChange("survey_options", index)}
                placeholder="Options"
                value={record.survey_options[index] || ""}
              />
            </div>
          ))}
        </div>
        <div className="mb-2">
          <div>Retest Surveys</div>
          {[0, 1, 2, 3, 4].map((index) => (
            <div className="flex gap-2 mb-1" key={`retest-survey-${index}`}>
              <Field
                label=""
                name={`retest_survey_ids_${index}`}
                onChange={onArrayChange("retest_survey_ids", index)}
                options={surveyOptions}
                placeholder="None"
                type="select"
                value={String(record.retest_survey_ids[index] || "")}
              />
              <textarea
                onChange={onArrayChange("retest_survey_options", index)}
                placeholder="Options"
                value={record.retest_survey_options[index] || ""}
              />
            </div>
          ))}
        </div>
        <div className="flex gap-2 mt-4">
          <button className="btn btn-blue" type="submit">Save</button>
          {id && <button className="btn btn-red" onClick={onDestroy} type="button">Delete</button>}
        </div>
      </form>
    </div>
  );
}
